import {BaseWidget} from "./BaseWidget";
import {
    documentFileEntityTypes,
    doesFieldHaveAllowedValues,
    getAllowedValuesFor,
    isEntityEnabled,
    isSimpleEntity,
    masterFileEntityTypes,
    showFieldInfoFor,
    sortedAllEntityTypes,
    sortedSimpleAndOtherAllEntityTypes
} from "../login/ClientCache";
import * as DomainBaseEntities from "../constants/DomainBaseEntities";

import * as CommonConstants from "../constants/CommonConstants";
import * as FieldType from "../constants/FieldType";
import {isAnyEqualToFirst} from "../common/NamaCommon";
import * as StringUtils from "../common/StringUtils";
import {constructDataFromAllowedValues} from "../views/list/ListViewColumns";
import {modelId} from "../grid/NamaGridWidget";

export class DropDownListWidget extends BaseWidget {

    afterAttach() {
        super.afterAttach();
        let that = this;
        let allowedValues = prepareAllowedValues(that.fieldMetadata, that.domainClassName);
        if (doesFieldHaveAllowedValues(that.owner.id, that.fieldMetadata.fieldId))
            allowedValues = getAllowedValuesFor(that.owner.id, that.fieldMetadata.fieldId);
        let prefix = that.fieldMetadata.enumTypeName ? that.fieldMetadata.enumTypeName + "." : "";
        let data = constructDataFromAllowedValues(allowedValues, prefix);
        let options = {
            dataTextField: "text",
            dataValueField: "value",
            filter: "contains",
            dataSource: {data: data},
            open: (e) => {
                that.open = true;
            },
            close: (e) => {
                setTimeout(() => {
                    that.open = false;
                }, 150);
            },
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            }
        };
        if (that.insideGrid && that.fieldMetadata.fieldType == FieldType.Genericreference && that.id.endsWith(".entityType")) {
            options.change = (e) => {
                that.cellOptions.model.set(modelId(that.id), that.dropDown().value());
            };
        }
        if (that.owner.docTypeSelectedInTerm && that.owner.place && that.owner.place.entityType === DomainBaseEntities.DocumentTerm && that.id === "documentType")
            options.change = (e) => {
                that.owner.docTypeSelectedInTerm();
            };
        that.findElement().kendoDropDownList(options);
        that.dropDown().wrapper.on("focus", (e) => {
            if (!that.open)
                setTimeout((e) => that.dropDown().open(), 155);
        });
        that.dropDown().wrapper.on("contextmenu", (e) => {
            showFieldInfoFor(that.owner.entityType, that.id, that.referenceTable(), e, that.owner);
        });
        if (that.criteriaEditorBlock)
            that.dropDown().bind("change", () => that.criteriaEditorBlock.approvalEntityChanged(that.dropDown().value()));
        else if (that.dynamicSelectorUpdater)
            that.dropDown().bind("change", () => that.dynamicSelectorUpdater.updateDynamicSelectors(true));
    }

    setValueInElement(value) {
        let dropDown = this.dropDown();
        if (!dropDown)
            return;
        if (value === undefined)
            value = null;
        dropDown.value(value);
    }

    /**
     * @returns {kendo.ui.DropDownList}
     */
    dropDown() {
        return this.findElement().data("kendoDropDownList");
    }

    readValueFromElement() {
        return this.dropDown().value();
    }

    setEnabled(enabled) {
        let that = this;
        if (enabled === "Enabled" || enabled === true) {
            that.dropDown().enable(true);
            that.dropDown().wrapper.addClass("enabledDropDown");
        } else {
            that.dropDown().enable(false);
            that.dropDown().wrapper.removeClass("enabledDropDown");
        }

    }
}

export function dropDownFiltering(ev, dataSource) {
    let inputText = ev.filter != undefined ? ev.filter.value : "";
    ev.preventDefault();
    let filters = [];
    filters.push({
        field: "searchData",
        operator: "contains",
        value: inputText
    });
    filters.push({
        field: "searchData",
        operator: "contains",
        value: StringUtils.normalizeArabic(inputText)
    });
    filters.push({
        field: "searchData",
        operator: "contains",
        value: StringUtils.normalizeArabic(StringUtils.englishToArabic(inputText))
    });
    filters.push({
        field: "searchData",
        operator: "contains",
        value: StringUtils.arabicToEnglish(inputText).toLowerCase()
    });
    dataSource.filter({
        logic: "or",
        filters: filters
    });
}

export function prepareAllowedValues(fieldMetadata, domainClassName) {
    let allowedValues = fieldMetadata.allowedValues || [];
    if (!allowedValues.length) {
        if (isForEnum("EntityTypeDF", fieldMetadata, domainClassName) || !domainClassName)
            allowedValues = sortedAllEntityTypes;
        else if (isForEnum("DocumentEntityTypeDF", fieldMetadata, domainClassName))
            allowedValues = documentFileEntityTypes;
        else if (isForEnum("MasterEntityTypeDF", fieldMetadata, domainClassName))
            allowedValues = masterFileEntityTypes;
    }
    if (allowedValues.length === 1 && (isForEnum("EntityTypeDF", fieldMetadata, domainClassName) || isAnyEqualToFirst(allowedValues[0], CommonConstants.GENERIC_REF_ALL,
        CommonConstants.GENERIC_REF_ALL_DOCS, CommonConstants.GENERIC_REF_ALL_MASTERS))) {
        if (allowedValues[0] === CommonConstants.GENERIC_REF_ALL)
            allowedValues = sortedAllEntityTypes;
        else if (allowedValues[0] === CommonConstants.GENERIC_REF_ALL_DOCS)
            allowedValues = documentFileEntityTypes;
        else if (allowedValues[0] === CommonConstants.GENERIC_REF_ALL_MASTERS)
            allowedValues = masterFileEntityTypes;
        else if (allowedValues[0] === CommonConstants.GENERIC_REF_SIMPLE_AND_ALL)
            allowedValues = sortedSimpleAndOtherAllEntityTypes;
    }
    if (allowedValues && fieldMetadata.fieldType === FieldType.EntityType)
        allowedValues = allowedValues.filter(value => isEntityEnabled(value) || isSimpleEntity(value));
    return allowedValues;
}

function isForEnum(enumName, fieldMetadata, domainClassName) {
    if (!enumName)
        return false;
    if (fieldMetadata.enumTypeName === enumName)
        return true;
    if (domainClassName && domainClassName.endsWith("." + enumName))
        return true;
    return false;
}